import { fetchJsonByDelete, fetchJsonByGet, fetchJsonByPost, fetchJsonByPut } from './execute';
import {
  convertTemplateResponse,
  convertTemplatesResponse,
  getTemplateInfo,
} from '../converters/templateConverter';
import TemplateComposer from '../model/templates/TemplateComposer';
import { getParams } from '../reducers/analyticsApp';

export const getTemplates = (dispatch, getState) => {
  const state = getState();
  const templateInfo = getTemplateInfo(state);

  return fetchJsonByGet('/templates/list?full=true', getParams(state)).then((response) => ({
    templates: convertTemplatesResponse(response, templateInfo),
  }));
};

export const createTemplate = (templateName, templateDescription, type) => (dispatch, getState) => {
  const state = getState();
  const templateInfo = getTemplateInfo(state);

  return fetchJsonByPost(
    '/templates',
    TemplateComposer(state, templateName, templateDescription, type),
    getParams(state)
  ).then((response) => ({
    template: convertTemplateResponse(response, templateInfo),
  }));
};

export const updateTemplate = (templateName, templateDescription, type) => (dispatch, getState) => {
  const state = getState();
  const templateInfo = getTemplateInfo(state);

  return fetchJsonByPut(
    '/templates',
    TemplateComposer(state, templateName, templateDescription, type),
    getParams(state)
  ).then((response) => ({
    template: convertTemplateResponse(response, templateInfo),
  }));
};

export const deleteTemplate = (id) => (dispatch, getState) =>
  fetchJsonByDelete(`/templates/${id}`, getParams(getState())).then((response) => ({
    id: response.id,
  }));
